module.exports = __webpack_public_path__ + "src/assets/games/15/78.jpg";